import "./SharePostModal.css";
import "font-awesome/css/font-awesome.min.css";
import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from "react";
import ImageTemplate from "../../../pages/sharepost/ImageTemplate";
import Popup from "../../popup/Popup";
import PropTypes from "prop-types";
import ShareToInstagram from "./instagram/ShareToInstagram";
import ShareToTwitter from "./x/ShareToTwitter";
import ShareToMessages from "./message/ShareToMessages";
import DownloadImage from "../../../pages/sharepost/DownloadImage";
// import useImageHandling from "../../../hooks/useImageHandling";
import { AuthContext } from "../../../context/AuthContext";
import useLinkGenerator from "../../../pages/sharepost/LinkGenerator";

const SharePostModal = ({ 
  isOpen, 
  closeModal, 
  details,
}) => {

  // if(!details) return <></>;

  const {user} = useContext(AuthContext);
  // used for selecting the social media icon
  const [selectedItem, setSelecteditem] = useState(0)
  // state to track the selected image index
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  // if share.can() exists, use the share api for downloading image
  const [err, setErr] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  // const [shareGeneratedElements, setShareGeneratedElements] = useState([]);
  const shareGeneratedElementsRef = useRef([]);
  const [shareIsLoadingImage, setShareIsLoadingImage] = useState(true);
  const [generateLinkNow, setGenerateLinkNow] = useState(false);
  const [generatedLink, setGeneratedLink] = useState();
  const [linkOrWishlist, setLinkOrWishlist] = useState();
  const [showDownloadBtn, setShowDownloadBtn] = useState(true);
  // const [lastStep, setIsLastStep] = useState();
  // const [generatedDownloadElements, setGeneratedDownloadElements] = useState([])
  const generateLink = useLinkGenerator();
  const cloudfrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;
  // Array of objects representing each social media option and its corresponding Font Awesome class
  const socialOptions = [
    { name: "Instagram", iconClass: 'fa fa-instagram',  src: `${cloudfrontUrl}/static/instagram-brands-solid.svg` },
    { name: "Twitter", iconClass: 'fa fa-twitter', src: `${cloudfrontUrl}/static/x-twitter-brands-solid.svg` },
    {name: "Messages", iconClass: 'fa fa-comment', src: `${cloudfrontUrl}/static/message-solid.svg` },
    // {name: "Clipboard", iconClass: 'fa fa-clone' }
  ]; 
 
  useEffect(() => {
    if(details.type === "wishlist"){
      setLinkOrWishlist("wishlist");
    } else {
      setLinkOrWishlist("link");
    }
  }, [details]);

  // TODO: CHECK IF WE ARE GENERATING LINK FOR WISHLIST OR LINK
  // this is used in link generation, not wishlist
  useEffect(() => {
    if (err) {
      setShowPopup(true);
    } else if (details.type != "wishlist" && generateLinkNow){
      getUserLink();
      setGenerateLinkNow(false);
    }
  }, [err, linkOrWishlist, generateLinkNow])
  
  const getUserLink = async () => {
    const userLink = await generateLink(user, details);
    setGeneratedLink(userLink);
  } 

  const memoizedGeneratedElements = useMemo(() => {
    return shareGeneratedElementsRef.current;
  }, [shareGeneratedElementsRef.current]);

  const handleSelectItem = useCallback((index) => {
    setSelectedImageIndex(0);
    setSelecteditem(index);
  }, []);
  
  

  // TODO: add share to snapchat function
  return (
    <div
      className={`modal ${isOpen ? "open" : ""}`}
      onClick={closeModal}>
      <Popup
        isPopupOpen={showPopup}
        message={err}
        button1Text="Close"
        button1Action={() => setShowPopup(false)}
      />
      <div
        className="modal-content-container"
        onClick={(e) => e.stopPropagation()}
      >
        <ul className="share-options">
          {socialOptions.map((option, index) => (
            <li
              key = {index}
              className={selectedItem === index ? "highlighted" : ""}
              onClick={() => {handleSelectItem(index)}}
            >
              <div className="icon-container">
                <img src={option.src} className="svg-icon" alt="Icon"></img>
              </div>
            </li>
          ))}
        </ul>

        <h2 className="share-headline">How to Share the Link</h2>
        {socialOptions[selectedItem]?.name === "Instagram" && (
          <ShareToInstagram
              setGenerateLinkNow={setGenerateLinkNow}
              generatedLink={generatedLink}
              generatedElements={memoizedGeneratedElements}
              isLoadingImage={shareIsLoadingImage}
              selectedImageIndex={selectedImageIndex}
              setSelectedImageIndex={setSelectedImageIndex}
              linkOrWishlist={linkOrWishlist}
              setShowDownloadBtn={setShowDownloadBtn}
              details={details}
          />
        )}
        {socialOptions[selectedItem]?.name === "Twitter" && (
          <ShareToTwitter
            setGenerateLinkNow={setGenerateLinkNow}
            generatedLink={generatedLink}
            generatedElements={memoizedGeneratedElements}
            isLoadingImage={shareIsLoadingImage}
            setSelectedImageIndex={setSelectedImageIndex}
            selectedImageIndex={selectedImageIndex}
            linkOrWishlist={linkOrWishlist}
            setShowDownloadBtn={setShowDownloadBtn}
            details={details}
        />
        )}
        {socialOptions[selectedItem]?.name === "Messages" && (
          <ShareToMessages
            setGenerateLinkNow={setGenerateLinkNow}
            generatedLink={generatedLink}
            generatedElements={memoizedGeneratedElements}
            isLoadingImage={shareIsLoadingImage}
            setSelectedImageIndex={setSelectedImageIndex}
            selectedImageIndex={selectedImageIndex}
            linkOrWishlist={linkOrWishlist}
            setShowDownloadBtn={setShowDownloadBtn}
            details={details}
        />
        )}
        <div className="download-img-container">
          {/* download section */}
          {details && showDownloadBtn &&
            <DownloadImage
              details={details}
              templateIndex={selectedImageIndex}
              // downloadFunction={downloadFunction}
              setErr={setErr}
            />
          }
        </div>
      </div>
      <div className="offscreen">
          <ImageTemplate
            details={details}
            setShareGeneratedElements={(elements) => {
              shareGeneratedElementsRef.current = elements;
            }}
            setIsLoadingImage={setShareIsLoadingImage}
            scale={1}
            idName="shareImageTemplate"
          />
        </div>
    </div>
  );
};

export default SharePostModal;

SharePostModal.propTypes = {
  details: PropTypes.object,
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  linkGenerated: PropTypes.bool,
  generatedLink: PropTypes.string,
  shouldRenderOffscreen: PropTypes.bool
  // generatedElements: PropTypes.array,
  // isLoadingImage: PropTypes.bool
};
